import clsx from "clsx";
import { useEffect, useState } from "react";

/* eslint-disable-next-line */
export interface WPasswordStrengthProps {
  passwordValue: string;
}

export function WPasswordStrength({ ...props }: WPasswordStrengthProps) {
  const poorPassRegex = /[a-z]/;
  const weakPassRegex = /(?=.*?[0-9])/;
  const strongPassRegex = /(?=.*?[#?!@$%^&*-])/;
  const [passWordStrength, setPassWordStrength] = useState<
    "empty" | "poor" | "weak" | "strong"
  >("empty");

  const poorPass =
    (props.passwordValue.length < 8 && props.passwordValue.length > 0) ||
    (poorPassRegex.test(props.passwordValue) &&
      !weakPassRegex.test(props.passwordValue) &&
      !strongPassRegex.test(props.passwordValue));
  const weakPass =
    weakPassRegex.test(props.passwordValue) &&
    !strongPassRegex.test(props.passwordValue);
  const strongPass = strongPassRegex.test(props.passwordValue);
  const emptyPass = props.passwordValue.length === 0;

  useEffect(() => {
    if (poorPass) {
      setPassWordStrength("poor");
    } else if (weakPass) {
      setPassWordStrength("weak");
    } else if (strongPass) {
      setPassWordStrength("strong");
    } else if (emptyPass) {
      setPassWordStrength("empty");
    }
  }, [emptyPass, passWordStrength, poorPass, strongPass, weakPass]);

  return (
    <div>
      <div>
        <progress
          max="100"
          value={
            passWordStrength === "poor"
              ? 25
              : passWordStrength === "weak"
                ? 50
                : passWordStrength === "strong"
                  ? 100
                  : 0
          }
          className={clsx(
            "ek-progress",
            passWordStrength === "poor"
              ? "low"
              : passWordStrength === "weak"
                ? "medium"
                : passWordStrength === "strong"
                  ? "high"
                  : "empty"
          )}
        ></progress>
        <div className="flex justify-between">
          <div>Parola</div>
          <div
            className={clsx(
              "font-bold",
              passWordStrength === "poor"
                ? "text-ekred"
                : passWordStrength === "weak"
                  ? "text-orange-400"
                  : passWordStrength === "strong"
                    ? "text-ekgreen"
                    : "text-gray-400 font-normal"
            )}
          >
            {passWordStrength === "poor"
              ? "SLABA"
              : passWordStrength === "weak"
                ? "MEDIE"
                : passWordStrength === "strong"
                  ? "PUTERNICA"
                  : "Introdu parola"}
          </div>
        </div>
      </div>
    </div>
  );
}

export default WPasswordStrength;
